// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"table-of-content_wrapper__V1B_L","item":"table-of-content_item__oGFso","itemArrow":"table-of-content_itemArrow__FQPYY"};